import React from 'react';
import { FiCheckCircle, FiShield, FiTrendingUp } from 'react-icons/fi';
import ContactForm from './ContactForm';

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden pt-8 sm:pt-10">
      <div className="pointer-events-none absolute -right-28 top-0 h-72 w-72 rounded-full bg-[#f2643f]/20 blur-3xl" />
      <div className="pointer-events-none absolute -left-24 bottom-8 h-72 w-72 rounded-full bg-[#3182ce]/20 blur-3xl" />
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-center gap-10 pb-14 pt-4 sm:pb-16 lg:grid-cols-12 lg:gap-12 lg:pb-20">
          <div className="lg:col-span-7 lg:pr-3">
            <div className="max-w-3xl">
              <span className="inline-flex items-center gap-2 rounded-full border border-[#f6c7b4] bg-[#fff1e8] px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.14em] text-[var(--brand-accent-strong)]">Online cancellation service</span>

              <h1 className="mt-6 text-4xl leading-[1.04] text-[var(--brand-deep)] sm:text-5xl lg:text-6xl">
                CANCEL YOUR SUBSCRIPTION FREE AND IMMEDIATELY THROUGH OUR ONLINE CANCELLATION SERVICE.
              </h1>

              <p className="mt-5 max-w-2xl text-lg text-[var(--text-muted)] sm:text-xl">Our operators are trained by our partners to answer all your questions quickly and efficiently.</p>


              <div className="mt-10 grid gap-4 sm:grid-cols-3">
                <div className="rounded-2xl border border-[#e4edf6] bg-white/90 p-4 shadow-[0_20px_42px_-34px_rgba(13,27,42,0.75)]">
                  <div className="flex items-center gap-3">
                    <div className="rounded-xl bg-[#fff1e8] p-2 text-[var(--brand-accent)]"><FiCheckCircle className="h-5 w-5" /></div>
                    <div>
                      <div className="text-sm font-semibold text-[var(--brand-ink)]">Simplified support</div>
                      <div className="text-sm text-[var(--text-muted)]">Manage your subscription in one click.</div>
                    </div>
                  </div>
                </div>

                <div className="rounded-2xl border border-[#e4edf6] bg-white/90 p-4 shadow-[0_20px_42px_-34px_rgba(13,27,42,0.75)]">
                  <div className="flex items-center gap-3">
                    <div className="rounded-xl bg-[#e9f2fb] p-2 text-[#2b6cb0]"><FiShield className="h-5 w-5" /></div>
                    <div>
                      <div className="text-sm font-semibold text-[var(--brand-ink)]">Recognized expertise</div>
                      <div className="text-sm text-[var(--text-muted)]">We support partner sites professionally.</div>
                    </div>
                  </div>
                </div>

                <div className="rounded-2xl border border-[#e4edf6] bg-white/90 p-4 shadow-[0_20px_42px_-34px_rgba(13,27,42,0.75)]">
                  <div className="flex items-center gap-3">
                    <div className="rounded-xl bg-[#fff1e8] p-2 text-[var(--brand-accent)]"><FiTrendingUp className="h-5 w-5" /></div>
                    <div>
                      <div className="text-sm font-semibold text-[var(--brand-ink)]">Agents at your service</div>
                      <div className="text-sm text-[var(--text-muted)]">Fast and expert responses.</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-center lg:col-span-5 lg:justify-end">
            <div className="w-full max-w-md rounded-[1.8rem] border border-[#f6c7b4] bg-white/95 p-5 shadow-[0_32px_90px_-45px_rgba(13,27,42,0.95)] backdrop-blur-md sm:p-6">
              <h2 className="text-lg font-bold text-[var(--brand-ink)]">Get help now</h2>
              <p className="mt-2 text-sm text-[var(--text-muted)]">Enter the email used when subscribing and our agents will help you.</p>
              <div className="mt-4">
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
